export function isApiSellingPlanFixedAmountPriceAdjustment(priceAdjustment) {
    return 'adjustmentAmount' in priceAdjustment;
}
export function isApiSellingPlanFixedPriceAdjustment(priceAdjustment) {
    return 'price' in priceAdjustment;
}
export function isApiSellingPlanPercentagePriceAdjustment(priceAdjustment) {
    return 'adjustmentPercentage' in priceAdjustment;
}
